import React from "react";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import HomeIcon from "@mui/icons-material/Home";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import MovieFilterIcon from "@mui/icons-material/MovieFilter";
import DescriptionIcon from "@mui/icons-material/Description";

import CustomForm from "../../../helper-components/form/CustomForm.jsx";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter.jsx";

import HighlightsTable from "./components/HighlightsTable.jsx";

import { getLanguage } from "../../../config/language/language.js";

/**
 * The highlights page.
 */
export default function Highlights(props) {
    // Cancel the review queue if it exists.
    React.useEffect(() => {
        if (!props.backend.highlightReviewQueue) return;
        props.backend.setHighlightReviewQueue(null);

        props.showSnackbar({ message: "Review process cancelled", color: "warning" });
    }, []);

    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().HIGHLIGHT_TITLE} subtitle={getLanguage().HIGHLIGHT_SUBTITLE} icon={<MovieFilterIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <HighlightsTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={2}
                    options={[
                        {
                            path: `/database/resources`,
                            title: "Resources",
                            variant: "outlined",
                            icon: <DescriptionIcon />
                        },
                        {
                            path: `/highlights/requests`,
                            title: "Highlight requests",
                            variant: "outlined",
                            icon: <LightbulbIcon />
                        },
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
